import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page61() {
  useEffect(() => {
    document.title = "Маяк — Страница 60"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page59" />
        <ForwardLink href="/page61" />
      </div>

      <p style={{ textAlign: "right" }}>60.</p>
      <p style={{ display: "flex" }}>
        <div>
          <div style={{ textAlign: "center" }}>МОЛОДОЙ (ПРОДОЛЖЕНИЕ)</div>
          Повара из жестяных кухонных лачуг<br/>
          давали нам жареные пончики три<br/>
          раза в день и деревенскую ветчину<br/>
          больше, чем твой кулак.
        </div>
        <div style={{ marginLeft: "auto" }}>
          <div style={{ textAlign: "center" }}>СТАРИК</div>
          Ты пьян, иначе бы ты<br/>
          не говорил это! Ты пьян! Ты<br/>
          пьян! Ты пьян!
        </div>
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        <i>Я</i> пьян? <u><i>Я</i></u> пьян?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Ты слышал, что я сказал.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Ты был пьян с тех пор...
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Будь ты проклят.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Пьян с тех пор, как я впервые увидел<br/>
        тебя.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Тебе ведь нравится мой лобстер?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Ты пьянее, чем забор в Вирджинии.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Я видел, как тебе нравился мой лобстер.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        --
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Скажи это.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        --
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Скажи это.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        --
      </p>
      <p>Старик в ярости.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Будь ты проклят!
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я не должен ничего говорить--
      </p>
      <p style={{ textAlign: "right" }}>60.</p>

      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page59" />
        <ForwardLink href="/page61" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710629643/the-lighthouse-script/i5aodslylv4kah5qlnly.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page61;
